import React, { useState } from 'react';

const ContentSections = ({
  sections = [],
  className = '',
  collapsible = false,
  summaryLabel = 'Page details'
}) => {
  const [open, setOpen] = useState(false);

  if (!sections.length) return null;

  const content = (
    <section className={`content-sections ${className}`.trim()} aria-label="Page details">
      {sections.map(section => (
        <article className="content-section" key={section.title}>
          <h2>{section.title}</h2>
          {section.paragraphs.map(paragraph => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </article>
      ))}
    </section>
  );

  if (!collapsible) return content;

  return (
    <details
      className="content-disclosure"
      open={open}
      onToggle={(event) => setOpen(event.currentTarget.open)}
    >
      <summary>{summaryLabel}</summary>
      {content}
    </details>
  );
};

export default ContentSections;
